

module.exports = __webpack_require__.stylable.create(
    "DeclineGroupRequestModal1385560655",
    {"classes":{"root":"DeclineGroupRequestModal1385560655__root","rejectionReasonInput":"DeclineGroupRequestModal1385560655__rejectionReasonInput"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    3,
    "DeclineGroupRequestModal1385560655",
    null
);
